module.exports = __webpack_public_path__ + "img/shop.89625d3f.svg";